import Checkbox from "@/Components/Checkbox/Checkbox";
import { ObjectByString, getValue } from "@/shared/utils/helpers";
import { memo } from "react";
import { BaseRow, TableId, rowStyling } from "./types";

interface TableRowsProps {
  rows: BaseRow[];
  handleSet: (value: number) => void;
  onRowClick?: (row: any) => void;
  isActive: (id: number) => boolean;
  data: any[];
  id: TableId;
  disableAction?: boolean;
  onRowsStyling?: rowStyling[];
  disabledActionForRow?: any[];
  selectableRows?: boolean;
  isGroupActive?: (group_id: string) => boolean;
  setGroupActive?: (group_id: string) => void;
}

const TableRows = ({
  rows,
  onRowClick,
  data,
  id,
  handleSet,
  isActive,
  disableAction = false,
  selectableRows = false,
  setGroupActive,
  disabledActionForRow,
  isGroupActive,
}: TableRowsProps) => {
  const handleClick = (e: any, value: any) => {
    e.stopPropagation();
    value !== undefined && handleSet(value);
  };

  return rows.map((row, key) => (
    <tr onClick={(e) =>
        onRowClick
          ? onRowClick(data[key])
          : selectableRows
          ? handleClick(e, getValue(ObjectByString(row._original, `${id}`)))
          : undefined
      } key={
        row?._group ? row._id : getValue(ObjectByString(row._original, `${id}`))
      } {...(row.styles.border
        ? { backgroundColor: "transparent !important" }
        : {})} style={row.styles}>
      {!disableAction &&
        (disabledActionForRow?.includes(data?.[key]?.[id]) ? (
          <td></td>
        ) : (
          <td onClick={(e) => e.stopPropagation()}>
            <Checkbox
              active={
                row?._group
                  ? isGroupActive(row._id)
                  : isActive(
                      getValue(ObjectByString(row._original, `${id}`))
                    ) || false
              }
              onChange={(e) =>
                row?._group
                  ? setGroupActive(row._id)
                  : handleClick(
                      e,
                      getValue(ObjectByString(row._original, `${id}`))
                    )
              }
              sizing={"mini"}
            />
          </td>
        ))}
      {Object.entries(row)
        .filter(([k]) => {
          return (
            k !== "_original" &&
            k !== "styles" &&
            k !== "_group" &&
            k !== "_id" &&
            k !== "_group_id"
          );
        })
        .map(([k, values]) => {
          return (
            <td key={
                row._group
                  ? `${row._id}_group_${k}`
                  : `${getValue(ObjectByString(row._original, `${id}`))}_${k}`
              }>
              {values}
            </td>
          );
        })}
    </tr>
  ));
};

// @ts-ignore
export default memo(TableRows);
